/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum Status4B4Enum {
	created = "created",
	waiting_payment = "waiting_payment",
	waiting_deferred_payment = "waiting_deferred_payment",
	partial_paid = "partial_paid",
	paid = "paid",
	failed_payment = "failed_payment",
	failed_after_paid = "failed_after_paid",
	waiting_creation_iiko = "waiting_creation_iiko",
	failed = "failed",
	sent = "sent",
	confirmed = "confirmed",
	failed_after_sent = "failed_after_sent",
	waiting_for_fiscalization = "waiting_for_fiscalization",
	sent_fiscalization = "sent_fiscalization",
	failed_after_sent_fiscalization = "failed_after_sent_fiscalization",
	fake_fiscalized = "fake_fiscalized",
	fiscalized = "fiscalized",
	payment_initiation = "payment_initiation",
	payment_initiation_retry = "payment_initiation_retry",
	failed_after_payment_initiation = "failed_after_payment_initiation",
	waiting_for_refund = "waiting_for_refund",
	refunded = "refunded",
	refund_failed = "refund_failed",
	waiting_manual_action = "waiting_manual_action",
	completed = "completed",
	cancelled = "cancelled",
}
